/* Jellyfish.News dashboard — every sale tied to Jellyfish and nothing else.
   Reads its own encrypted snapshot (assets/jellyfish-data.js), separate from the
   main CTM dashboard so this page can be shared without exposing the rest of the
   store. Reuses dashboard.css; no external dependencies. */

(function () {
  'use strict';

  var root = document.getElementById('ctmjf-root');
  if (!root) return;

  var SESSION_KEY = 'ctmjf.unlocked.v1';
  var D = null;

  /* ── formatting ──────────────────────────────────────────────────────── */

  var nf = new Intl.NumberFormat('en-US');
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function money(cents) {
    var a = Math.abs((cents || 0) / 100);
    return (cents < 0 ? '-' : '') + '$' + nf.format(Math.round(a));
  }
  function moneyExact(cents) {
    return (cents < 0 ? '-' : '') + '$' +
      (Math.abs(cents || 0) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function num(n) { return nf.format(Math.round(n || 0)); }
  function fmtDay(iso, withYear) {
    var p = iso.split('-');
    return MONTHS[+p[1] - 1] + ' ' + +p[2] + (withYear ? ', ' + p[0] : '');
  }
  function fmtMonth(iso) { var p = iso.split('-'); return MONTHS[+p[1] - 1] + " '" + p[0].slice(2); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function addDays(iso, n) {
    var t = new Date(iso + 'T12:00:00Z');
    t.setUTCDate(t.getUTCDate() + n);
    return t.toISOString().slice(0, 10);
  }

  /* ── decryption gate ─────────────────────────────────────────────────── */

  function b64ToBytes(b64) {
    var bin = atob(b64), out = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
    return out;
  }

  async function decrypt(payload, password) {
    var baseKey = await crypto.subtle.importKey(
      'raw', new TextEncoder().encode(password), 'PBKDF2', false, ['deriveKey']
    );
    var key = await crypto.subtle.deriveKey(
      { name: 'PBKDF2', salt: b64ToBytes(payload.salt), iterations: payload.iter, hash: 'SHA-256' },
      baseKey, { name: 'AES-GCM', length: 256 }, false, ['decrypt']
    );
    var plain = await crypto.subtle.decrypt(
      { name: 'AES-GCM', iv: b64ToBytes(payload.iv) }, key, b64ToBytes(payload.data)
    );
    if (payload.gz) {
      if (typeof DecompressionStream === 'undefined') {
        throw new Error('This browser is too old to read the dashboard (needs DecompressionStream). Try Chrome, Edge, or Safari 16.4+.');
      }
      var stream = new Blob([plain]).stream().pipeThrough(new DecompressionStream('gzip'));
      return JSON.parse(await new Response(stream).text());
    }
    return JSON.parse(new TextDecoder().decode(plain));
  }

  function renderGate(message) {
    root.innerHTML =
      '<div class="ctmd-gate">' +
        '<h1>Jellyfish.News</h1>' +
        '<p>Donations, merch, and recurring support for Jellyfish. Enter the dashboard password to continue.</p>' +
        '<label for="ctmjf-pw">Password</label>' +
        '<input id="ctmjf-pw" type="password" autocomplete="current-password" spellcheck="false">' +
        '<button id="ctmjf-go" type="button">Unlock</button>' +
        '<div class="ctmd-gate__err" role="alert">' + esc(message || '') + '</div>' +
      '</div>';

    var input = document.getElementById('ctmjf-pw');
    var btn = document.getElementById('ctmjf-go');
    var err = root.querySelector('.ctmd-gate__err');

    async function attempt() {
      if (!input.value) return;
      btn.disabled = true;
      err.textContent = 'Decrypting…';
      try {
        D = await decrypt(window.__CTM_JELLYFISH__, input.value);
        try { sessionStorage.setItem(SESSION_KEY, input.value); } catch (e) {}
        renderApp();
      } catch (e) {
        btn.disabled = false;
        err.textContent = /too old/.test(e.message) ? e.message : 'That password didn’t work.';
        input.select();
      }
    }
    btn.addEventListener('click', attempt);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') attempt(); });
    input.focus();
  }

  /* ── state & ranges ──────────────────────────────────────────────────── */

  var S = { preset: 'all', from: null, to: null, theme: 'light', sort: { key: 'cents', dir: -1 } };

  function lastDay() { return D.days[D.days.length - 1]; }

  var PRESETS = [
    ['30d', 'Last 30 days'], ['90d', 'Last 90 days'], ['mtd', 'Month to date'],
    ['ytd', 'Year to date'], ['12m', 'Last 12 months'], ['all', 'All time'],
  ];

  function currentRange() {
    var end = lastDay(), start;
    if (S.preset === 'custom') {
      var f = S.from || D.days[0], t = S.to || end;
      if (f > t) { var tmp = f; f = t; t = tmp; }
      return { from: f < D.days[0] ? D.days[0] : f, to: t > end ? end : t };
    }
    switch (S.preset) {
      case '30d': start = addDays(end, -29); break;
      case '90d': start = addDays(end, -89); break;
      case 'mtd': start = end.slice(0, 8) + '01'; break;
      case 'ytd': start = end.slice(0, 4) + '-01-01'; break;
      case '12m': start = addDays(end, -364); break;
      default: start = D.days[0];
    }
    if (start < D.days[0]) start = D.days[0];
    return { from: start, to: end };
  }

  function idxOf(iso) {
    var i = D.days.indexOf(iso);
    if (i !== -1) return i;
    for (var j = 0; j < D.days.length; j++) if (D.days[j] >= iso) return j;
    return D.days.length - 1;
  }

  /* ── aggregation ─────────────────────────────────────────────────────── */

  /** Every Jellyfish line item inside the range. */
  function eventsInRange(a, b) {
    return D.events.filter(function (e) { return e.d >= a && e.d <= b; });
  }

  function summarise(events) {
    var t = {
      cents: 0, donationCents: 0, merchCents: 0, recurringCents: 0,
      gifts: 0, merchUnits: 0, orders: events.length,
    };
    var supporters = {};
    events.forEach(function (e) {
      var p = D.products[e.p];
      t.cents += e.c;
      supporters[e.u] = 1;
      if (p.cat === 'Donation') { t.donationCents += e.c; t.gifts += 1; }
      else { t.merchCents += e.c; t.merchUnits += e.q; }
      if (e.s) t.recurringCents += e.c;
    });
    t.supporters = Object.keys(supporters).length;
    return t;
  }

  function byProduct(events) {
    var map = {};
    events.forEach(function (e) {
      var p = D.products[e.p];
      var row = map[e.p] || (map[e.p] = {
        name: p.n, cat: p.cat, cents: 0, units: 0, count: 0, recurringCents: 0, isAmount: false,
      });
      row.cents += e.c;
      row.count += 1;
      if (e.q === 0) row.isAmount = true; else row.units += e.q;
      if (e.s) row.recurringCents += e.c;
    });
    return Object.keys(map).map(function (k) { return map[k]; });
  }

  /** Monthly buckets — Jellyfish volume is far too sparse to read daily. */
  function monthly(events, a, b) {
    var buckets = [], index = {};
    for (var i = a; i <= b; i++) {
      var m = D.days[i].slice(0, 7);
      if (index[m] === undefined) {
        index[m] = buckets.length;
        buckets.push({ month: m, label: D.days[i], donation: 0, merch: 0 });
      }
    }
    events.forEach(function (e) {
      var m = D.days[e.d].slice(0, 7);
      var bk = buckets[index[m]];
      if (!bk) return;
      if (D.products[e.p].cat === 'Donation') bk.donation += e.c / 100;
      else bk.merch += e.c / 100;
    });
    // Jellyfish launched partway into the tracked window, so drop the empty months
    // before its first sale rather than pad the axis with them.
    var firstWithData = 0;
    while (firstWithData < buckets.length - 1 &&
           !buckets[firstWithData].donation && !buckets[firstWithData].merch) firstWithData++;
    return buckets.slice(firstWithData);
  }

  /* ── chart ───────────────────────────────────────────────────────────── */

  var SVGNS = 'http://www.w3.org/2000/svg';
  function el(name, attrs) {
    var n = document.createElementNS(SVGNS, name);
    for (var k in attrs) if (attrs[k] != null) n.setAttribute(k, attrs[k]);
    return n;
  }
  function niceTicks(max, count) {
    if (max <= 0) return [0, 1];
    var raw = max / count, mag = Math.pow(10, Math.floor(Math.log10(raw))), norm = raw / mag;
    var step = (norm <= 1 ? 1 : norm <= 2 ? 2 : norm <= 2.5 ? 2.5 : norm <= 5 ? 5 : 10) * mag;
    var ticks = [];
    for (var v = 0; v <= max + step * 0.001; v += step) ticks.push(v);
    if (ticks[ticks.length - 1] < max) ticks.push(ticks[ticks.length - 1] + step);
    return ticks;
  }

  /** Stacked monthly columns: donations and merch against one axis. */
  function columnChart(host, buckets) {
    var W = host.clientWidth || 640, H = 260;
    var PAD = { t: 14, r: 16, b: 28, l: 56 };
    host.innerHTML = '';

    var tip = document.createElement('div');
    tip.className = 'ctmd-tip';
    host.appendChild(tip);

    if (!buckets.length) {
      host.insertAdjacentHTML('beforeend', '<div class="ctmd-empty">No Jellyfish sales in this range.</div>');
      return;
    }

    var max = buckets.reduce(function (m, b) { return Math.max(m, b.donation + b.merch); }, 0);
    var ticks = niceTicks(max, 4), top = ticks[ticks.length - 1] || 1;
    var iw = W - PAD.l - PAD.r, ih = H - PAD.t - PAD.b;
    var svg = el('svg', { width: W, height: H, viewBox: '0 0 ' + W + ' ' + H, role: 'img',
      'aria-label': 'Jellyfish donations and merch revenue by month' });

    var y = function (v) { return PAD.t + ih - (v / top) * ih; };
    ticks.forEach(function (t) {
      svg.appendChild(el('line', { x1: PAD.l, x2: W - PAD.r, y1: y(t), y2: y(t),
        class: t === 0 ? 'ctmd-baseline' : 'ctmd-gridline' }));
      var lbl = el('text', { x: PAD.l - 8, y: y(t) + 4, class: 'ctmd-axis-label', 'text-anchor': 'end' });
      lbl.textContent = '$' + num(t);
      svg.appendChild(lbl);
    });

    var slot = iw / buckets.length;
    var bw = Math.min(24, slot * 0.6);
    var every = Math.max(1, Math.ceil(buckets.length / 8));

    buckets.forEach(function (b, i) {
      var cx = PAD.l + slot * i + slot / 2;
      var x = cx - bw / 2;
      var total = b.donation + b.merch;

      // merch stacks on top of donations, with a 2px surface gap between them
      var yDon = y(b.donation), hDon = y(0) - yDon;
      if (b.donation > 0) {
        svg.appendChild(el('rect', { x: x, y: yDon, width: bw, height: Math.max(1, hDon),
          rx: 4, fill: 'var(--series-1)' }));
      }
      if (b.merch > 0) {
        var yTop = y(total), hM = Math.max(1, y(b.donation) - yTop - (b.donation > 0 ? 2 : 0));
        svg.appendChild(el('rect', { x: x, y: yTop, width: bw, height: hM, rx: 4, fill: 'var(--series-2)' }));
      }

      if (i % every === 0 || i === buckets.length - 1) {
        var t = el('text', { x: cx, y: H - 8, class: 'ctmd-axis-label', 'text-anchor': 'middle' });
        t.textContent = fmtMonth(b.label);
        svg.appendChild(t);
      }

      var hit = el('rect', { x: PAD.l + slot * i, y: PAD.t, width: slot, height: ih, fill: 'transparent' });
      hit.addEventListener('mouseenter', function () {
        tip.innerHTML = '<strong>' + esc(fmtMonth(b.label)) + '</strong>' +
          '<div class="ctmd-tip__row"><i class="ctmd-tip__key" style="background:var(--series-1)"></i>Donations <strong>' + moneyExact(b.donation * 100) + '</strong></div>' +
          '<div class="ctmd-tip__row"><i class="ctmd-tip__key" style="background:var(--series-2)"></i>Merch <strong>' + moneyExact(b.merch * 100) + '</strong></div>';
        tip.style.opacity = 1;
        var tw = tip.offsetWidth;
        tip.style.left = Math.min(Math.max(cx - tw / 2, 0), W - tw) + 'px';
        tip.style.top = Math.max(0, y(total) - tip.offsetHeight - 10) + 'px';
      });
      hit.addEventListener('mouseleave', function () { tip.style.opacity = 0; });
      svg.appendChild(hit);
    });

    host.appendChild(svg);
  }

  /* ── render ──────────────────────────────────────────────────────────── */

  function renderApp() {
    var gen = new Date(D.generatedAt);
    root.setAttribute('data-theme', S.theme);
    root.innerHTML =
      '<div class="ctmd__wrap">' +
        '<div class="ctmd-head">' +
          '<h1>Jellyfish.News</h1>' +
          '<div class="ctmd-head__meta">Data through ' + esc(fmtDay(lastDay(), true)) +
            ' · built ' + esc(gen.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })) + '</div>' +
          '<div class="ctmd-head__spacer"></div>' +
          '<button class="ctmd-ghost" id="ctmjf-theme" type="button">' + (S.theme === 'dark' ? 'Light mode' : 'Dark mode') + '</button>' +
          '<button class="ctmd-ghost" id="ctmjf-lock" type="button">Lock</button>' +
        '</div>' +
        '<div id="ctmjf-body"></div>' +
      '</div>';

    root.querySelector('#ctmjf-theme').addEventListener('click', function () {
      S.theme = S.theme === 'dark' ? 'light' : 'dark';
      renderApp();
    });
    root.querySelector('#ctmjf-lock').addEventListener('click', function () {
      try { sessionStorage.removeItem(SESSION_KEY); } catch (e) {}
      D = null;
      renderGate('');
    });
    renderBody();
  }

  function renderBody() {
    var host = document.getElementById('ctmjf-body');
    var r = currentRange();
    var a = idxOf(r.from), b = idxOf(r.to);
    var events = eventsInRange(a, b);
    var t = summarise(events);
    var rows = byProduct(events);

    var rangeLabel = S.preset === 'all'
      ? 'All time · ' + fmtDay(D.days[0], true) + ' – ' + fmtDay(lastDay(), true)
      : fmtDay(r.from, true) + ' – ' + fmtDay(r.to, true);

    var k = S.sort.key, dir = S.sort.dir;
    rows.sort(function (x, y) {
      var vx = k === 'name' ? x.name.toLowerCase() : k === 'cat' ? x.cat : x[k];
      var vy = k === 'name' ? y.name.toLowerCase() : k === 'cat' ? y.cat : y[k];
      return vx < vy ? -dir : vx > vy ? dir : 0;
    });
    var maxCents = rows.reduce(function (m, q) { return Math.max(m, q.cents); }, 1);

    function th(key, label, cls) {
      return '<th ' + (cls || '') + ' data-sort="' + key + '"' +
        (k === key ? ' aria-sort="' + (dir === -1 ? 'descending' : 'ascending') + '"' : '') + '>' +
        label + (k === key ? (dir === -1 ? ' ↓' : ' ↑') : '') + '</th>';
    }

    // catalogue items that have not sold in this range
    var soldNames = {};
    rows.forEach(function (q) { soldNames[q.name] = 1; });
    var unsold = (D.catalog || []).filter(function (c) { return !soldNames[c.n]; });

    host.innerHTML =
      '<div class="ctmd-filters">' +
        PRESETS.map(function (p) {
          return '<button class="ctmd-chip" data-preset="' + p[0] + '" aria-pressed="' + (S.preset === p[0]) + '">' + p[1] + '</button>';
        }).join('') +
        '<span class="ctmd-filters__rule"></span>' +
        '<input type="date" id="ctmjf-from" value="' + r.from + '" min="' + D.days[0] + '" max="' + lastDay() + '" aria-label="From date">' +
        '<input type="date" id="ctmjf-to" value="' + r.to + '" min="' + D.days[0] + '" max="' + lastDay() + '" aria-label="To date">' +
        '<span class="ctmd-filters__note">' + esc(rangeLabel) + '</span>' +
      '</div>' +

      '<div class="ctmd-grid ctmd-grid--kpi">' +
        '<div class="ctmd-hero">' +
          '<p class="ctmd-hero__label">Total raised for Jellyfish</p>' +
          '<p class="ctmd-hero__value">' + money(t.cents) + '</p>' +
          '<div class="ctmd-delta ctmd-delta--flat"><span>' + num(t.supporters) +
            ' supporter' + (t.supporters === 1 ? '' : 's') + ' · ' + num(t.orders) + ' purchases</span></div>' +
        '</div>' +
        tile('Donations', money(t.donationCents), num(t.gifts) + ' gifts') +
        tile('Merch', money(t.merchCents), num(t.merchUnits) + ' items') +
        tile('Recurring in range', money(t.recurringCents), 'from monthly supporters') +
        tile('Active monthly gifts', num(D.recurringActive), money(D.recurringMonthlyCents) + ' / mo') +
        tile('Supporters', num(t.supporters), 'distinct buyers') +
        tile('Average gift', t.gifts ? moneyExact(Math.round(t.donationCents / t.gifts)) : '—', 'per donation') +
      '</div>' +

      '<div class="ctmd-card">' +
        '<h2>Donations and merch by month</h2>' +
        '<p class="ctmd-card__sub">Stacked monthly totals. Jellyfish volume is sparse, so months read better than days.</p>' +
        '<div class="ctmd-legend">' +
          '<span class="ctmd-legend__item"><i class="ctmd-legend__key" style="background:var(--series-1)"></i>Donations</span>' +
          '<span class="ctmd-legend__item"><i class="ctmd-legend__key" style="background:var(--series-2)"></i>Merch</span>' +
        '</div>' +
        '<div class="ctmd-chart" id="ctmjf-chart"></div>' +
      '</div>' +

      '<div class="ctmd-card">' +
        '<div class="ctmd-card__head"><h2>Every Jellyfish sale</h2>' +
          '<span class="ctmd-card__sub" style="margin:0">' + num(rows.length) + ' products sold in this range</span></div>' +
        (rows.length ?
          '<div class="ctmd-tablewrap" id="ctmjf-table"><table class="ctmd-table"><thead><tr>' +
            th('name', 'Product') + th('cat', 'Type') +
            th('count', 'Purchases', 'class="ctmd-num"') + th('units', 'Items', 'class="ctmd-num"') +
            th('cents', 'Amount', 'class="ctmd-num"') + '<th style="width:16%"></th>' +
          '</tr></thead><tbody>' +
          rows.map(function (p) {
            return '<tr><td>' + esc(p.name) +
                (p.recurringCents ? '<span class="ctmd-table__sub">includes ' + moneyExact(p.recurringCents) + ' recurring</span>' : '') +
              '</td>' +
              '<td>' + esc(p.cat) + '</td>' +
              '<td class="ctmd-num">' + num(p.count) + '</td>' +
              '<td class="ctmd-num">' + (p.isAmount ? '—' : num(p.units)) + '</td>' +
              '<td class="ctmd-num">' + moneyExact(p.cents) + '</td>' +
              '<td><span class="ctmd-bar__track"><i class="ctmd-bar" style="width:' +
                Math.max(2, (p.cents / maxCents) * 100) + '%;background:' +
                (p.cat === 'Donation' ? 'var(--series-1)' : 'var(--series-2)') + '"></i></span></td></tr>';
          }).join('') + '</tbody></table></div>'
          : '<div class="ctmd-empty">No Jellyfish sales in this range.</div>') +
      '</div>' +

      (unsold.length ?
        '<div class="ctmd-card">' +
          '<h2>Listed but not sold in this range</h2>' +
          '<p class="ctmd-card__sub">Jellyfish products that exist in the store with no sales in the selected period.</p>' +
          '<div class="ctmd-tablewrap"><table class="ctmd-table"><thead><tr>' +
            '<th>Product</th><th>Type</th><th>Status</th></tr></thead><tbody>' +
          unsold.map(function (c) {
            return '<tr><td>' + esc(c.n) + '</td><td>' + esc(c.cat) +
              (c.t ? '<span class="ctmd-table__sub">' + esc(c.t) + '</span>' : '') + '</td>' +
              '<td>' + (c.st === 'ACTIVE' ? 'Active' : esc(c.st.toLowerCase())) + '</td></tr>';
          }).join('') + '</tbody></table></div>' +
        '</div>' : '') +

      '<p class="ctmd-note">Covers every product whose name mentions Jellyfish — donations, recurring gifts, and the ' +
      'Jellyfish.News merch line — and nothing else in the store. Amounts are after discounts, before shipping and tax; ' +
      'cancelled and test orders are excluded. "Support Jellyfish" is a $1 product bought in quantity, so its quantity is ' +
      'dollars pledged rather than a count of items — its Items column reads “—” for that reason. ' +
      'Active monthly gifts counts supporters whose most recent recurring charge landed within the last cycle plus a grace period.</p>';

    host.querySelectorAll('[data-preset]').forEach(function (btn) {
      btn.addEventListener('click', function () { S.preset = btn.getAttribute('data-preset'); renderBody(); });
    });
    ['from', 'to'].forEach(function (key) {
      var input = host.querySelector('#ctmjf-' + key);
      input.addEventListener('change', function () {
        var cur = currentRange();
        S.from = key === 'from' ? input.value : cur.from;
        S.to = key === 'to' ? input.value : cur.to;
        S.preset = 'custom';
        renderBody();
      });
    });
    host.querySelectorAll('#ctmjf-table th[data-sort]').forEach(function (h) {
      h.addEventListener('click', function () {
        var key = h.getAttribute('data-sort');
        S.sort = { key: key, dir: S.sort.key === key ? -S.sort.dir : -1 };
        renderBody();
      });
    });

    columnChart(document.getElementById('ctmjf-chart'), monthly(events, a, b));
    window.addEventListener('resize', debouncedRedraw);
  }

  function tile(label, value, sub) {
    return '<div class="ctmd-tile"><p class="ctmd-tile__label">' + esc(label) + '</p>' +
      '<p class="ctmd-tile__value">' + value + '</p>' +
      (sub ? '<div class="ctmd-delta ctmd-delta--flat"><span>' + esc(sub) + '</span></div>' : '') + '</div>';
  }

  var redrawTimer = null;
  function debouncedRedraw() {
    clearTimeout(redrawTimer);
    redrawTimer = setTimeout(function () {
      if (!D) return;
      var r = currentRange(), a = idxOf(r.from), b = idxOf(r.to);
      var host = document.getElementById('ctmjf-chart');
      if (host) columnChart(host, monthly(eventsInRange(a, b), a, b));
    }, 150);
  }

  /* ── boot ────────────────────────────────────────────────────────────── */

  if (!window.__CTM_JELLYFISH__) {
    root.innerHTML = '<div class="ctmd-gate"><h1>Jellyfish.News</h1>' +
      '<p>The data snapshot hasn’t been generated yet. Run <code>node tools/dashboard-build.mjs</code> and deploy.</p></div>';
    return;
  }
  if (!window.crypto || !window.crypto.subtle) {
    root.innerHTML = '<div class="ctmd-gate"><h1>Jellyfish.News</h1>' +
      '<p>This page needs a secure (https) connection to decrypt its data.</p></div>';
    return;
  }

  (async function () {
    var saved = null;
    try { saved = sessionStorage.getItem(SESSION_KEY); } catch (e) {}
    if (saved) {
      try {
        D = await decrypt(window.__CTM_JELLYFISH__, saved);
        renderApp();
        return;
      } catch (e) {
        try { sessionStorage.removeItem(SESSION_KEY); } catch (e2) {}
      }
    }
    renderGate('');
  })();
})();
